import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { constant } from '../../../app.constants';
import { ParentService } from '../ParentClass/ParentService';

@Injectable()
export class ManifestService extends ParentService {

  endPoint: string;
  manifestLoadedSubject = new BehaviorSubject<boolean>(false);
  manifestLoaded$ = this.manifestLoadedSubject.asObservable();

  private paymentStatusIdSubject = new BehaviorSubject<number | null>(null);
  paymentStatusId$ = this.paymentStatusIdSubject.asObservable();

  constructor(private _http: Http, private route: Router, private toastrAlertHelper: ToastrAlertHelper) {
    super();
  }

  getManifest(tripIdInput: number) {
    const url = `${constant.URL_MANIFEST}/${tripIdInput}`;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getClaimManifest(tripIdInput) {
    return this._http.get(`${constant.URL_MANIFEST}/${tripIdInput}`, this.getFileHeaders())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  storeManifest(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(this.endPoint, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw( this.toastrAlertHelper.error(error.json().message)));
  }

  postTripManifest(data) {
    return this._http.post(constant.URL_MANIFEST, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  getTripsByIds(data) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_LIST_TRIPS_BY_IDS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => this.validate401Error(error, this.route));
  }

  processManifest(tripId: number) {
    const url = `${constant.URL_MANIFEST_EXTRACT}/${tripId}`;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  setManifestLoaded(hasManifest: boolean): void {
    this.manifestLoadedSubject.next(!!hasManifest);
  }

  setPaymentStatusId(statusId: number): void {
    this.paymentStatusIdSubject.next(statusId);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/manifest/manifest.service.ts